import {Injectable} from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import {OrganisationsService} from '../services/core/organisations.service';
import {AuthService} from '../services/core/auth.service';

@Injectable({
  providedIn: 'root'
})
export class OrganisationsGuard {

  /**
   *
   * @param router
   */
  constructor(private router: Router) {
  }

  /**
   *
   */
  public async canActivate(): Promise<boolean | UrlTree> {
    const authToken = AuthService.getAuthToken();
    if(authToken) {
      return this.router.createUrlTree(['/login']);
    }
    return true;
  }

  /**
   *
   */
  public async canDeactivate(): Promise<boolean | UrlTree> {
    return !!OrganisationsService.getOrganisation();
  }

}
